"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDeepEqual = void 0;
/**
 * Проверяет переданное объект на соотвествие другому объекту
 * @example
 * isDeepEqual({ a: [ 0 ] }, { a: [ 0 ] }) // -> true
 */
function isDeepEqual(a, b) {
    return a === b || JSON.stringify(a) === JSON.stringify(b);
}
exports.isDeepEqual = isDeepEqual;
//# sourceMappingURL=isDeepEqual.js.map